module.exports = __webpack_public_path__ + "static/media/southamerican.7a5c2228.jpg";